var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('div',{attrs:{"id":"app"}},[_c('progress-bar',{ref:"progressBar"}),_vm._v(" "),_c('transition',{attrs:{"enter-active-class":"fadeIn","leave-active-class":"fadeOut"}},[_c(_vm.layout,{tag:"component",staticClass:"animated"})],1)],1)}
var staticRenderFns = []
module.exports = { render: render, staticRenderFns: staticRenderFns }


//////////////////
// WEBPACK FOOTER
// ./node_modules/vue-loader/lib/template-compiler?{"id":"data-v-5557945e","hasScoped":false,"buble":{"transforms":{}}}!./node_modules/vue-loader/lib/selector.js?type=template&index=0!./resources/js/core/App.vue
// module id = oxr+
// module chunks = 66